export { default } from './GridDictionaries.vue'
